import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa14095e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "table-name" }
const _hoisted_3 = { class: "round" }
const _hoisted_4 = { class: "odd" }
const _hoisted_5 = { class: "even" }
const _hoisted_6 = {
  class: "one",
  "data-label": "1"
}
const _hoisted_7 = {
  class: "two",
  "data-label": "2"
}
const _hoisted_8 = {
  class: "three",
  "data-label": "3"
}
const _hoisted_9 = {
  class: "four",
  "data-label": "4"
}
const _hoisted_10 = {
  class: "five",
  "data-label": "5"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fill-w" }, null, -1))
const _hoisted_12 = { class: "map-wrap" }
const _hoisted_13 = {
  key: 0,
  class: "limit-wrap"
}
const _hoisted_14 = { class: "title" }
const _hoisted_15 = { class: "limits" }
const _hoisted_16 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_road_map = _resolveComponent("road-map")!

  return (_openBlock(), _createElementBlock("div", {
    class: "loby-list-item-fantan-root",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('select-table', _ctx.mdata.tableNo)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, "经典番摊" + _toDisplayString(_ctx.mdata.tableNo) + "台", 1),
      _createElementVNode("div", {
        class: _normalizeClass(["timer", _ctx.timerColor])
      }, _toDisplayString(_ctx.currentCount === -1 ? '' : _ctx.currentCount), 3),
      _createElementVNode("div", _hoisted_3, "局数:" + _toDisplayString(_ctx.mapData.round), 1),
      _createElementVNode("div", _hoisted_4, "单:" + _toDisplayString(_ctx.mapData.oddCount), 1),
      _createElementVNode("div", _hoisted_5, "双:" + _toDisplayString(_ctx.mapData.evenCount), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.mapData.oneCount), 1),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.mapData.twoCount), 1),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.mapData.threeCount), 1),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.mapData.fourCount), 1),
      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.mapData.fiveCount), 1),
      _hoisted_11,
      _createElementVNode("div", {
        class: "button-toggle-view",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.display = _ctx.display === 1 ? 0 : 1), ["stop"]))
      }, _toDisplayString(_ctx.display == 0 ? '单双' : '点数'), 1)
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_road_map, {
        class: "map",
        "map-data": _ctx.mdata.result,
        display: _ctx.display,
        onRoadMapData: _ctx.OnMapDataChange
      }, null, 8, ["map-data", "display", "onRoadMapData"])
    ]),
    (_ctx.selected === _ctx.mdata.tableNo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.t('selectlimit')), 1),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.limits, (limit) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item btn",
                key: limit.Id,
                onClick: _withModifiers(($event: any) => (_ctx.enterTable(limit)), ["stop"])
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.t('minlimit')) + ": " + _toDisplayString(limit.Min), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.t('maxlimit')) + ": " + _toDisplayString(limit.Max), 1)
              ], 8, _hoisted_16))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}